<mat-tab-group class="bg-primary rounded-t m-2" mat-stretch-tabs>
  <mat-tab label="PRODUCTION DETAILS">
    <div class="bg-white">
      <ciwc-order-production-details
        [parentForm]="parentForm"
        [viewDisable]="viewDisable"
        [orderDetails]="orderDetails"
        [details]="details"
        [itemProcesses]="itemProcesses"
        [readonlySpecFields]="readonlySpecFields"
      ></ciwc-order-production-details>
    </div>
    <div class="bg-gray-100">
      <ciwc-order-construction-steps
        [parentForm]="parentForm"
        [viewDisable]="viewDisable"
        [readonly]="readonlySpecFields"
        [specification]="parentForm.get('specification')?.value"
        (constructionStepsChange)="onConstructionStepsChange($event)"
      ></ciwc-order-construction-steps>
    </div>
  </mat-tab>
  <mat-tab label="MATERIALS NEEDED">
    <div class="bg-white">
      <ciwc-order-materials-needed
        [parentForm]="parentForm"
        [viewDisable]="viewDisable"
        [orderDetails]="orderDetails"
      ></ciwc-order-materials-needed>
    </div>
  </mat-tab>
  <mat-tab label="SHIPPING DETAILS">
    <div class="bg-white">
      @if (viewDisable) {
        <ciwc-order-shipping-view [orderDetails]="orderDetails"></ciwc-order-shipping-view>
      } @else {
        <ciwc-order-shipping-details
          [parentForm]="parentForm"
          [orderDetails]="orderDetails"
          [viewDisable]="viewDisable"
          [createShipmentGroup]="createShipmentGroup"
        >
        </ciwc-order-shipping-details>
      }
    </div>
  </mat-tab>
</mat-tab-group>
